module.exports = __webpack_public_path__ + "static/meniu_desk-7433976e664adb6df44f01016d2e2fcf.mp4";